import { Grid } from '@material-ui/core';
import React from 'react';
import { PortalButton } from 'src/components/Buttons';
import { t } from 'i18next';
import { PortalMenuButton } from 'src/components/Menus';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { Config } from 'src/state';

interface Props {
  className?: string;
  canSign: boolean;
  onReject: () => void;
  onSign: () => void;
}

const SignMenu = ({ canSign, onReject, onSign }: Props) => {
  let isFromMvpApp: boolean;
  isFromMvpApp = useUrlParameterCheck('/app');
  const isRealKreditSign = Config.isRealkreditDenmark() ? 'secondary' : 'error';

  return (
    <Grid container={true} justifyContent="flex-end" spacing={1}>
      <Grid item={true} xs={12} sm={12} md={4}>
        <PortalButton
          style={{ display: 'flex', justifyContent: 'center' }}
          disabled={!canSign}
          onClick={onSign}
          fullWidth={true}
          tabIndex={0}
          data-testid="sign-btn"
          colorType={isFromMvpApp ? 'mvpBlue' : 'primary'}
        >
          {t('Sign')}
        </PortalButton>
      </Grid>
      <Grid item={true} xs={12} sm={12} md={4}>
        <PortalMenuButton
          onClick={onReject}
          fullWidth={true}
          tabIndex={0}
          data-testid="reject-btn"
          colorType={isFromMvpApp ? 'mvpRed' : isRealKreditSign}
        >
          {t('Reject')}
        </PortalMenuButton>
      </Grid>
    </Grid>
  );
};

export default SignMenu;
